import React from "react";
import { ScrollView, View } from "react-native";

import CalendarIntegrationPage from "./calendar/CalendarIntegrationPage";
import DesktopIntegration from "./desktop/DesktopIntegration";
import DesktopIntegrationDownloadStarted from "./desktop/DesktopIntegrationDownloadStarted";
import DesktopIntegrationEmailSent from "./desktop/DesktopIntegrationEmailSent";
import HealthIntegration from "./health/HealthIntegration";
import HealthIntegrationDone from "./health/HealthIntegrationDone";
import steps from "./steps";
import appStyles from "../../../appStyles";
import { isAppleDevice, isWeb, navigate } from "../../../../helpers/utils";
import GetStartedChecklist from "../../animation/info/GetStartedChecklist";
import CarouselProgressBar from "../../animation/progressBar/CarouselProgressBar";
import appPages from "../../../../appPages";
import ProgressBarConfig from "../../animation/progressBar/config";
import ManaButton from "../../common/ManaButton";
import SetupConfig from "../../home/cards/onboarding/SetupConfig";
import SettingsHelper from "../../more/SettingsHelper";

export default class IntegrationsOnboardingPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    const params = this.getArgs() || {};
    this.state = {
      step: params.step || steps.calendar,
      isFromCard: params.isFromCard,
    };
  }

  getArgs() {
    if (this.controller.hasNavigation()) {
      return this.props.route.params;
    } else {
      return this.controller.state.screenArgs?.args;
    }
  }

  goToStep = (nextStep) => {
    if (nextStep == steps.profile) {
      if (this.state.isFromCard) {
        this.controller.navigate("feed");
      } else {
        navigate(this.controller, appPages.onboardingPage);
      }
      return;
    }
    if (nextStep == steps.done) {
      // Save current step in settings for checklist display
      SettingsHelper.updateSetupProgress(this.controller, {
        [SetupConfig.integrations.name]: true,
      });

      return navigate(this.controller, appPages.customizeElementsPage);
    }

    this.setState((state) => ({ ...state, step: nextStep }));
  };

  goBack = () => {
    this.goToStep(
      isAppleDevice ? steps.health : isWeb ? steps.desktop : steps.calendar,
    );
  };

  render() {
    const { step, isFromCard } = this.state;

    const ComponentTag =
      step == steps.calendar
        ? CalendarIntegrationPage
        : step == steps.desktop
        ? DesktopIntegration
        : step == steps.desktopAdded
        ? isWeb
          ? DesktopIntegrationDownloadStarted
          : DesktopIntegrationEmailSent
        : step == steps.health
        ? HealthIntegration
        : HealthIntegrationDone;

    const currentScreenIndex = ProgressBarConfig["integrationsChecklist"];
    const numberOfScreens = Object.keys(ProgressBarConfig).length;

    return (
      <View style={appStyles.container}>
        {step == steps.checklist ? (
          <>
            <CarouselProgressBar
              currentScreenIndex={currentScreenIndex}
              numberOfScreens={numberOfScreens}
              changeScreen={this.goBack}
              hideNext
            />

            <ScrollView
              style={appStyles.scrollView}
              contentContainerStyle={appStyles.scrollViewContent}
            >
              <GetStartedChecklist currentStep={3} title="Let’s finish up!" />
            </ScrollView>

            <View style={appStyles.footerButtons}>
              <ManaButton
                isMainButton
                text={"Continue"}
                style={appStyles.bottomButton}
                styleText={appStyles.bottomButtonText}
                onPress={() => this.goToStep(steps.done)}
              />
            </View>
          </>
        ) : (
          <ComponentTag
            controller={this.controller}
            goToStep={this.goToStep}
            isFromCard={isFromCard}
            step={step}
          />
        )}
      </View>
    );
  }
}
